export const LOADING = "LOADING";
export const MESSAGE = "MESSAGE";
export const ERROR = "ERROR";
export const RESET = "RESET";